import { PersonCircle } from "react-bootstrap-icons";

interface UserIconProps{
        userdetailsHandler:()=>void;
   }

   /// Questo componenete renderizza una icona cliccabile 
   export const UserIcon: React.FC<UserIconProps> = ({userdetailsHandler}) => {
    return (
            <a
             href='#'
             className='link-light'
             onClick={userdetailsHandler}
            >
                <PersonCircle color="black" size={40}></PersonCircle>
            </a>
    );
  };